// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1sZ0_","signatureButtonsRight":"ModalSign_signatureButtonsRight__2cQ3J"};